exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login-container .container-fluid{top:50%;transform:translateY(10%)}.login-container .container-fluid .img{width:50%;margin:auto;padding-bottom:20px}.login-container .container-fluid .input-group{padding-right:15px}.login-container .container-fluid .panel-footer{background:#fff}.login-container .container-fluid .facebook-btn{background:linear-gradient(180deg,#3f5fa3 0,#3b5998);color:#fff;width:96%;margin-left:2%;margin-top:10px}.login-container .container-fluid .or-wrapper{border-bottom:1px solid #eee;padding:10px 0;margin-bottom:30px;position:relative;margin-top:10px}.login-container .container-fluid .or-wrapper .or-text{position:absolute;left:46%;top:0;background:#fff;padding:3px 10px 10px;font-size:1.8rem}.modal #passwordResetButton{margin-top:10px}.modal .form-control{padding-right:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/login.less
 ** module id = 780
 ** module chunks = 0
 **/